<template>
  <v-dialog v-model="show" persistent content-class="elevation-0" width="420">
    <div class="dialog-cg-elite-required__wrapper">
      <div class="dialog-cg-elite-required__content">
        <div class="dialog-cg-elite-required__title">Unlock with CG Elite</div>

        <div class="dialog-cg-elite-required__text">
          This action is enabled to CG Elite customers only.<br />
          <a v-if="csmEmail" :href="`mailto:${csmEmail}`">Contact your CSM</a>
          <span v-else>Contact your CSM</span>
          to renew your CG Elite subscription.
        </div>

        <div class="dialog-cg-elite-required__actions">
          <cg-button @click="show = false">OK</cg-button>
        </div>
      </div>

      <v-icon color="white" class="pointer" @click="show = false">mdi-close</v-icon>
    </div>
  </v-dialog>
</template>

<script>
import { CgButton } from '@corporategiftcom/design-system';

export default {
  name: 'DialogCgEliteRequired',
  components: { CgButton },
  props: {
    value: Boolean,
    csmEmail: {
      type: String,
      default: null,
    },
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.dialog-cg-elite-required {
  &__wrapper {
    gap: 12px;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-items: flex-start;
  }

  &__content {
    gap: 20px;
    display: flex;
    border-radius: 8px;
    background-color: #fff;
    flex-direction: column;
    align-items: flex-start;
    padding: 30px;
  }

  &__title {
    font-family: 'Lato-Bold', sans-serif;
    font-weight: 700;
    font-size: 18px;
    line-height: 22px;
    color: #000;
  }

  &__text {
    font-family: 'Lato-Regular', sans-serif;
    font-weight: 400;
    font-size: 15px;
    line-height: 22px;
    color: #000;

    a {
      color: #6e50ff;
      text-decoration: none;
    }
  }

  &__actions {
    gap: 12px;
    display: flex;
    flex-direction: row;

    & > button {
      border-radius: 100px;
    }
  }
}
</style>
